<template>
    <div class="gs-affiliate-settings-tab gs-affiliate-settings-tab--payment">
        <div class="gs-affiliate-settings-tab__head">
            <h2>{{ $t('frontend_affiliate_settings_payment') }}</h2>
        </div>
        <div class="gs-affiliate-settings-tab__body">
            <gd-tabs :tabs="affiliatePaymentSettingsTabs" :current-tab="affiliatePaymentSettingsTab"
                :wrapper-class="'gs-affiliate-settings__segmented'" :tab-class="'gs-affiliate-settings__segment'"
                :tab-active-class="'is-active'" :line-class="'gs-affiliate-settings__segment-line'"
                @onClick="handleAffiiatePaymentSettingsTabChange" />
            <div v-if="affiliatePaymentSettingsTab === 'paypal'" class="gs-affiliate-settings-tab__body--narrow">
                <gs-field :label="$t('frontend_affiliate_settings_paypal_email_id')">
                    <text-input v-model="localForm.affiliate_paypal_email" value="localForm.affiliate_paypal_email"
                        placeholder="email@paypal.com" />
                </gs-field>
            </div>
            <div v-else-if="affiliatePaymentSettingsTab === 'wire'" class="gs-affiliate-settings__grid">
                <gs-field class="gs-field--span-2" :label="$t('frontend_affiliate_settings_account_name')">
                    <text-input v-model="localForm.affiliate_wire_info.account_name"
                        value="localForm.affiliate_wire_info.account_name" :placeholder="$t('frontend_affiliate_settings_account_name')
                            " />
                </gs-field>
                <gs-field class="gs-field--span-2" :label="$t('frontend_affiliate_settings_address')">
                    <text-input v-model="localForm.affiliate_wire_info.address"
                        :value="localForm.affiliate_wire_info.address"
                        :placeholder="$t('frontend_affiliate_settings_address')" />
                </gs-field>
                <gs-field :label="$t('frontend_affiliate_settings_city')">
                    <text-input v-model="localForm.affiliate_wire_info.city"
                        value="localForm.affiliate_wire_info.city"
                        :placeholder="$t('frontend_affiliate_settings_city')" />
                </gs-field>
                <gs-field :label="$t('frontend_affiliate_settings_state')">
                    <text-input v-model="localForm.affiliate_wire_info.state"
                        value="localForm.affiliate_wire_info.state"
                        :placeholder="$t('frontend_affiliate_settings_state')" />
                </gs-field>
                <gs-field :label="$t('frontend_affiliate_settings_postal_code')">
                    <text-input v-model="localForm.affiliate_wire_info.postal_code"
                        value="localForm.affiliate_wire_info.postal_code" :placeholder="$t('frontend_affiliate_settings_postal_code')
                            " />
                </gs-field>
                <gs-field :label="$t('frontend_affiliate_settings_country')">
                    <text-input v-model="localForm.affiliate_wire_info.country"
                        value="localForm.affiliate_wire_info.country"
                        :placeholder="$t('frontend_affiliate_settings_country')" />
                </gs-field>
                <gs-field :label="$t('frontend_affiliate_settings_bank_name')">
                    <text-input v-model="localForm.affiliate_wire_info.main_bank_name"
                        value="localForm.affiliate_wire_info.main_bank_name" :placeholder="$t('frontend_affiliate_settings_bank_name')
                            " />
                </gs-field>
                <gs-field :label="$t('frontend_affiliate_settings_account_number')">
                    <text-input v-model="localForm.affiliate_wire_info.main_bank_account_no"
                        value="localForm.affiliate_wire_info.main_bank_account_no" :placeholder="$t('frontend_affiliate_settings_account_number')
                            " />
                </gs-field>
                <gs-field class="gs-field--span-2" :label="$t('frontend_affiliate_settings_bank_address')">
                    <text-input v-model="localForm.affiliate_wire_info.main_bank_address"
                        value="localForm.affiliate_wire_info.main_bank_address" :placeholder="$t('frontend_affiliate_settings_bank_address')
                            " />
                </gs-field>
                <gs-field :label="$t('frontend_affiliate_settings_routing_number')">
                    <text-input v-model="localForm.affiliate_wire_info.main_bank_routing_no"
                        value="localForm.affiliate_wire_info.main_bank_routing_no" :placeholder="$t('frontend_affiliate_settings_routing_number')
                            " />
                </gs-field>
                <gs-field :label="$t('frontend_affiliate_settings_swift')">
                    <text-input v-model="localForm.affiliate_wire_info.main_bank_swift_code"
                        value="localForm.affiliate_wire_info.main_bank_swift_code"
                        :placeholder="$t('frontend_affiliate_settings_swift')" />
                </gs-field>
                <gs-field :label="$t('frontend_affiliate_settings_aba')">
                    <text-input v-model="localForm.affiliate_wire_info.main_bank_aba"
                        value="localForm.affiliate_wire_info.main_bank_aba"
                        :placeholder="$t('frontend_affiliate_settings_aba')" />
                </gs-field>
                <gs-field :label="$t('frontend_affiliate_settings_iban')">
                    <text-input v-model="localForm.affiliate_wire_info.main_bank_iban"
                        value="localForm.affiliate_wire_info.main_bank_iban"
                        :placeholder="$t('frontend_affiliate_settings_iban')" />
                </gs-field>
            </div>
        </div>
        <footer class="gs-affiliate-settings-tab__footer">
            <gs-button variant="primary" size="md" @click="saveAffiliateSettings()">{{
                $t('frontend_save') }}</gs-button>
        </footer>
    </div>
</template>
<script>

export default {
    props: {
        form: {
            required: true
        },
        saveAffiliateSettings: {
            required: true,
            type: Function
        }
    },
    data() {
        return {
            localForm: this.form,
            affiliatePaymentSettingsTabs: [
                {
                    title: this.$t('frontend_affiliate_settings_paypal'),
                    value: 'paypal',
                },
                {
                    title: this.$t('frontend_affiliate_settings_wire'),
                    value: 'wire'
                },
            ],
            affiliatePaymentSettingsTab: 'paypal',
        }
    },
    watch: {
        localForm: {
            handler: function (val, oldVal) {
                console.log('Updating form:', val);
                this.$emit('update-form', val);
            },
            deep: true
        },
       
    },

    methods: {
        handleAffiiatePaymentSettingsTabChange(newTab) {
            this.affiliatePaymentSettingsTab = newTab;
        },
    }

}
</script>

